import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m9.54 16.17-3.57 1.96a.965.965 0 0 1-1.332-.433c-.101-.2-.136-.43-.1-.654l.682-4.155a1.06 1.06 0 0 0-.283-.912L2.048 9.034a1.064 1.064 0 0 1-.018-1.458.973.973 0 0 1 .565-.3l3.992-.607a.99.99 0 0 0 .743-.564l1.785-3.78c.241-.51.833-.72 1.322-.468.194.1.352.265.448.468l1.785 3.78a.991.991 0 0 0 .743.564l3.992.607c.54.081.913.605.835 1.168a1.048 1.048 0 0 1-.288.59l-2.889 2.943a1.06 1.06 0 0 0-.284.912l.721 4.155a1.054 1.054 0 0 1-.844 1.191.95.95 0 0 1-.626-.104l-3.57-1.961a.95.95 0 0 0-.92 0Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
